import clsx from 'clsx'
import classes from '../Card.module.scss'
import { Dialog } from '@educaplay/core'
import { Search } from '@educaplay/core/Icons/Search'
import { useState } from 'react';
// import PropTypes from 'prop-types'

export function CardImage({ cardData, className }) {
    const [openImage, setOpenImage] = useState(false);

    const handleClick = (e) => {
        setOpenImage(true);
        e.stopPropagation();
    }

    const handleDialogClose = (e) => {
        setOpenImage(false);
        e.stopPropagation();
    }

    return (
        <>
        <div className={clsx(classes.card__content, className)}>
            <img src={cardData.source} alt="" className={classes.card__image} />
            <div className={classes.card__filter} />
            <button type="button" className={classes.floatButton} onClick={handleClick}>
                <Search className={classes.floatButton__icon} />
            </button>
        </div>

        <Dialog open={openImage} onClose={handleDialogClose} variant="lightbox">
            <img src={cardData.source} alt="" />
        </Dialog>
        </>
    )
}

// CardImage.propTypes = {
//     imageSrc: PropTypes.string.isRequired
// }